import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import WhyTrustSection from '../components/sections/WhyTrustSection';
import IndustriesSection from '../components/sections/IndustriesSection';
import CustomerJourneySection from '../components/sections/CustomerJourneySection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <HowItWorksSection />
      <CustomerJourneySection />
      <WhyTrustSection />
      <IndustriesSection />
    </>
  );
};

export default HomePage;
